export enum CHART_TYPES {
  Area = 'area',
  Precipitation = 'precipitation',
  Yield = 'yield',
  Price = 'price',
  NDVI = 'ndvi',
  Health = 'health',
}
